<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="documents"
      >
        <template slot="columns">
          <th>ชื่อสกุล</th>
          <th>เบอร์โทร</th>
          <th>เลขทะเบียน</th>
          <th>เลขกรมธรรม์</th>
          <th>บัตรประชาชน</th>
          <th>กรมธรรม์เดิม</th>
          <th>สำเนาทะเบียนรถ</th>
          <th>เอกสารอื่นๆ</th>
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm"
                  >{{ row.name_prefix }} {{ row.name }}</span
                >
              </div>
            </div>
          </th>

          <td>
            {{ row.tel }}
          </td>
          <td>
            {{ row.license_plate }}
          </td>
          <td>
            {{ row.policy_number }}
          </td>
          <td class="text-center">
            <span v-if="row.assets !== null">
              <span v-if="JSON.parse(row.assets).hasOwnProperty('id_card')">
                <a
                  :href="
                    '/storage/' +
                      JSON.parse(row.assets).id_card
                  "
                  target="_blank"
                >
                  <img
                    src="/img/brand/ic_pdf.png"
                    width="16"
                    height="16"
                    alt="บัตรประชาชน"
                  /> </a
              ></span>
              <span v-else>-</span>
            </span>
            <span v-else>-</span>
            <!--<router-link to="/receipt/" class="ml-2">{{
              row.file
            }}</router-link>
            <router-link to="/receipt/" class="ml-2">
               <img src="/img/brand/ic_upload.png" width="16" alt="ใบเสร็จ" />
            </router-link>-->
          </td>
          <td class="text-center">
            <span
              :class="row.document === null ? 'invisible' : ''"
              v-if="row.document !== null"
              ><a
                :href="'/storage/' + row.document"
                target="_blank"
              >
                <img
                  src="/img/brand/ic_pdf.png"
                  width="16"
                  height="16"
                  alt="เอกสารพรบ."
                />
              </a>
            </span>
            <span v-else>-</span>
          </td>
          <!-- <td class="text-center">
            <span v-if="row.assets !== null">
              <span
                v-if="
                  JSON.parse(row.assets).hasOwnProperty('old_policy_number')
                "
              >
                <a
                  :href="
                    '/storage/' +
                      JSON.parse(row.assets).old_policy_number
                  "
                  target="_blank"
                >
                  <img
                    src="/img/brand/ic_pdf.png"
                    width="16"
                    height="16"
                    alt="กรมธรรม์เดิม"
                  /> </a
              ></span>
              <span v-else>-</span>
            </span>
            <span v-else>-</span>
          </td> -->
          <td class="text-center">
            <span v-if="row.assets !== null">
              <span
                v-if="JSON.parse(row.assets).hasOwnProperty('vehicle_regis')"
              >
                <a
                  :href="
                    '/storage/' +
                      JSON.parse(row.assets).vehicle_regis
                  "
                  target="_blank"
                >
                  <img
                    src="/img/brand/ic_pdf.png"
                    width="16"
                    height="16"
                    alt="สำเนาทะเบียนรถ"
                  /> </a
              ></span>
              <span v-else>-</span>
            </span>
            <span v-else>-</span>
            <!--<router-link to="/receipt/" class="ml-2">{{
              row.file
            }}</router-link>
            <router-link to="/receipt/" class="ml-2">
               <img src="/img/brand/ic_upload.png" width="16" alt="ใบเสร็จ" />
            </router-link>-->
          </td>
          <td class="text-center">
            <span v-if="row.assets !== null">
              <span v-if="JSON.parse(row.assets).hasOwnProperty('other')">
                <router-link :to="{ path: '/documentDetail/' + row.id }">
                  <img
                    src="/img/brand/ic_pdf.png"
                    width="16"
                    height="16"
                    alt="เอกสารอื่นๆ	"
                  /> </router-link
              ></span>
              <span v-else>-</span>
            </span>
            <span v-else>-</span>
            <!--<router-link to="/receipt/" class="ml-2">{{
              row.file
            }}</router-link>
            <router-link to="/receipt/" class="ml-2">
               <img src="/img/brand/ic_upload.png" width="16" alt="ใบเสร็จ" />
            </router-link>-->
          </td>
          <td>
            <router-link
              :to="{ path: '/documentDetail/' + row.id }"
              class="btn btn-primary btn-sm"
              >อัพโหลดเอกสาร</router-link
            >
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    ></div>
  </div>
</template>
<script>
import kickMixin from "../../mixins/kickMixin";
import axios from "axios";

export default {
  name: "document-table",
  mixins: [kickMixin],
  props: {
    type: {
      type: String,
    },
    title: String,
    documents: {
      type: Array,
      default: function() {
        return [];
      },
    },
    total: {
      type: Number,
    },
    page: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  methods: {
    search: async function(text) {
      var localApp = this;
      axios
        .get(
          "/api/document/search/q?keyword=" +
            text +
            "&page=" +
            localApp.page,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:documents", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          localApp.kick();
        });
    },
    loadAllDocument: async function() {
      var localApp = this;
      axios
        .get(
          "/api/document?page=" + localApp.page,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:documents", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          localApp.kick();
        });
    },
  },
  watch: {
    page: function() {
      if (
        this.$parent.keyword === ""
      ) {
        this.loadAllDocument();
      } else {
        this.search(this.$parent.keyword);
      }
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.loadAllDocument();
    }
  },
};
</script>
<style scoped>
.table td,
.btn-sm,
.text-sm {
  font-size: 1rem !important;
}
.table thead th,
.table th {
  font-size: 0.9rem !important;
}

.h3,
h3 {
  font-size: 1.2rem !important;
}
</style>
